import { formatValidQueryParamUrlCommaSeparated } from "utils/common";
import { emptySplitApi } from "./empty-split-api";

import {
  PatientNote,
  PatientNoteInput,
  PatientNotesFilter,
  PatientNotesResponse,
} from "./types/patient-notes.type";
import { formatPatientNote } from "utils/patients.util";
import { orderBy } from "lodash";

const DEFAULT_PATIENT_NOTES_QUERY =
  "{id,title,description,updated_at,created_at,created_by}";

const patientNotesApi = emptySplitApi.injectEndpoints({
  overrideExisting: true,
  endpoints: (builder) => ({
    getPatientNotes: builder.query<PatientNotesResponse, PatientNotesFilter>({
      query: ({ patientId, ...rest }) => {
        const customFiltersString = formatValidQueryParamUrlCommaSeparated({
          ...rest,
          query: rest.query || DEFAULT_PATIENT_NOTES_QUERY,
          ordering: "updated_at", //backend doesn't support this
        });

        return `/patients/${patientId}/notes/?${customFiltersString}`;
      },
      transformResponse: (response: PatientNotesResponse) =>
        orderBy(response.map(formatPatientNote), ["updated_at"], ["desc"]),
      providesTags: ["PatientNotes"],
    }),
    createPatientNote: builder.mutation<PatientNote, PatientNoteInput>({
      query: (input) => ({
        url: `/patients/${input.patient}/notes/`,
        method: "POST",
        body: input,
      }),
      invalidatesTags: ["PatientNotes"],
    }),
    updatePatientNote: builder.mutation<PatientNote, PatientNoteInput>({
      query: ({ id, ...rest }) => ({
        url: `/patients/${rest.patient}/notes/${id}/`,
        method: "PATCH",
        body: rest,
      }),
      invalidatesTags: ["PatientNotes"],
    }),
    deletePatientNote: builder.mutation<
      PatientNote,
      { patientId: number; id: number }
    >({
      query: ({ patientId, id }) => ({
        url: `/patients/${patientId}/notes/${id}/`,
        method: "DELETE",
      }),
      invalidatesTags: ["PatientNotes"],
    }),
  }),
});

export const {
  useGetPatientNotesQuery,
  useCreatePatientNoteMutation,
  useUpdatePatientNoteMutation,
  useDeletePatientNoteMutation,
} = patientNotesApi;
